import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const ConfigBasedRoute = ({ configParameter, ...props }) =>
  configParameter ? <Route {...props} /> : <Redirect to="/" />;
